import React from 'react'
import '../design/App.css'
import {
	ApiOutlined,
	UserOutlined,
	UserAddOutlined,
	LoginOutlined,
	CreditCardOutlined,
	PieChartOutlined,
	FireOutlined,
	ApartmentOutlined,
	LockOutlined,
	WechatOutlined,
	BarChartOutlined,
	FileTextOutlined,
	NotificationOutlined,
	LogoutOutlined,
	AppstoreOutlined,
	ThunderboltOutlined,
	GlobalOutlined
} from '@ant-design/icons'
/*
 * Pages
 */
// Info
import HomePage from '../pages/general/HomePage'
import HomePageTeam from '../pages/general/HomePageTeam'
import BlogMain from '../pages/general/Blog/BlogMain'
import AboutUs from '../pages/general/AboutUs/AboutUs'
import ContactUs from '../pages/general/ContactUs'
import TermsAndConditions from '../pages/general/TermsAndConditions'
import PrivacyPolicy from '../pages/general/PrivacyPolicy'

// Info - Services
import Wordpress from '../pages/general/Services/Wordpress'
import ProgrammingAndTech from '../pages/general/Services/ProgrammingAndTech'
import AutomationsAndAi from '../pages/general/Services/AutomationsAndAi'
import DigitalMarketing from '../pages/general/Services/DigitalMarketing'
import Business from '../pages/general/Services/Business'
import GraphicsAndDesign from '../pages/general/Services/GraphicsAndDesign'
import WritingAndTranslation from '../pages/general/Services/WritingAndTranslation'

// Features
import SprintsMain from '../pages/platform/Sprints/SprintsMain'
import MonthlyReportsMain from '../pages/platform/MonthlyReports/MonthlyReportsMain'
import SecuredMain from '../pages/platform/Secured/SecuredMain'
import RequestsMain from '../pages/platform/Requests/RequestsMain'
import WorkflowsMain from '../pages/platform/Workflows/WorkflowsMain'
import BudgetMain from '../pages/platform/Budget/BudgetMain'
import RecruitmentApply from '../pages/platform/Recruitment/RecruitmentApply'
import RecruitmentMain from '../pages/platform/Recruitment/RecruitmentMain'
import MeetingsSetter from '../pages/platform/Meetings/MeetingsSetter'
import MeetingsMain from '../pages/platform/Meetings/MeetingsMain'

// Management
import Subscriptions from '../pages/platform/Stripe/Subscriptions'
import DashboardMain from '../pages/platform/Dashboard/DashboardMain'

// Management - Users
import Logout from '../pages/platform/Users/Logout'
import ResetPassword from '../pages/platform/Users/ResetPassword'
import Login from '../pages/platform/Users/Login'
import Register from '../pages/platform/Users/Register'
import UsersMain from '../pages/platform/Users/UsersMain'
import NotificationsMain from '../pages/platform/Notifications/NotificationsMain'

// Others
import DocumentationMain from '../pages/platform/Documentation/DocumentationMain'

import LanguageSelector from '../components/Shared/LanguageSelector'
import { requiredVersion } from './versionUtils'
import CvEnWordpress from '../pages/cv/en/wordpress'
import CvEnMain from '../pages/cv/en/main'
import Poster from '../pages/cv/poster/'

// Subscriptions
import AiWpPublicChat from '../pages/products/ai-wp-public-chat/AiWpPublicChat'
/**
 * Array containing the menu routes configuration.
 * Each route includes path, label, component, and loggedInDisable properties.
 */
const routesAccount = [
	{
		key: 'settings',
		// icon: UserOutlined,
		label: <ApiOutlined />,
		published: true,
		notRoute: true, // Mark this as a non-route. Otherwise, it will be rendered as a route and override the parent route.
		children: [
			{
				key: 'language',
				// icon: GlobalOutlined,
				label: <LanguageSelector type="list" label="-" />,
				keyparent: 'settings'
			},
			{
				key: 'divider',
				type: 'divider'
			},
			{
				key: 'login',
				keyparent: 'settings',
				path: 'login',
				label: 'single.login.label',
				icon: LoginOutlined,
				component: Login,
				loggedInDisable: true,
				published: true
			},
			{
				key: 'signup',
				keyparent: 'settings',
				path: 'signup',
				label: 'single.signup.label',
				icon: UserAddOutlined,
				component: Register,
				loggedInDisable: true,
				published: true
			},
			{
				key: 'reset-password',
				keyparent: 'settings',
				path: 'reset-password',
				label: 'single.password.reset',
				icon: LockOutlined,
				component: ResetPassword,
				published: true
			},
			{
				key: 'logout',
				keyparent: 'settings',
				path: 'logout',
				label: 'single.sign-out',
				component: Logout,
				icon: LogoutOutlined,
				forceRegisterRoute: true,
				loggedInActive: true,
				published: true
			}
		]
	}
]

// Check if Info pages are published
const _routesSidePagesIsPublished = (key) => {
	const publishedRoutes = [
		'home',
		'blog',
		'contact-us',
		'recruitment-apply',
		'meeting-setter',
		'terms-and-conditions',
		'privacy-policy'
	]
	return publishedRoutes.includes(key)
}

// Check if the Pages are published
const _routesSideIsPublished = (key) => {
	return true
	const publishedRoutes = [
		'dashboard',
		'sprints',
		'workflows',
		'management',
		'billing'
	]
	return publishedRoutes.includes(key)
}

// Check if the Services are published
const _routesSideServicesIsPublished = (key) => {
	const publishedRoutes = []
	if (requiredVersion('1.2.0')) {
		publishedRoutes.push('/services/programming-tech/wordpress')
		publishedRoutes.push('/services/programming-tech')
		publishedRoutes.push('/services/automations-and-ai')
		publishedRoutes.push('/services/digital-marketing')
	}
	if (requiredVersion('1.3.0')) {
		publishedRoutes.push('/services/business')
		publishedRoutes.push('/services/graphics-design')
		publishedRoutes.push('/services/writing-translation')
	}
	return publishedRoutes.includes(key)
}

const _routesSideProductsIsPublished = (key) => {
	const publishedRoutes = []
	if (requiredVersion('1.0.0')) {
		publishedRoutes.push('/products/ai-wp-public-chat')
	}
	return publishedRoutes.includes(key)
}

/**
 * Array containing the sidebar routes configuration.
 * Each route includes path, label, component, loggedInActive properties and an icon.
 */
const routesSide = [
	{
		key: 'dashboard',
		id: 'menu-dashboard',
		path: 'dashboard',
		label: 'single.dashbord',
		component: DashboardMain,
		loggedInActive: true,
		icon: PieChartOutlined,
		published: _routesSideIsPublished('dashboard'),
		requiredVersion: requiredVersion('1.0.0')
	},
	{
		key: 'notifications',
		id: 'menu-notifications',
		path: 'notifications',
		pathWithChild: '/*',
		label: '_notification.multiple',
		icon: NotificationOutlined,
		component: NotificationsMain,
		loggedInActive: true,
		published: _routesSideIsPublished('notifications'),
		requiredVersion: requiredVersion('1.1.0')
	},
	{
		key: 'management',
		label: '_management',
		id: 'menu-management',
		loggedInActive: true,
		icon: UserOutlined,
		published: _routesSideIsPublished('management'),
		collapsedTitle: true,
		superAdminVersionOverride: true,
		requiredVersion: requiredVersion('1.0.0'),
		children: [
			{
				key: 'profile',
				id: 'menu-management-profile',
				keyparent: 'management',
				path: 'users/profile/edit',
				label: 'single.profile',
				loggedInActive: true,
				published: true,
				notRoute: true, // Mark this as a non-route. Otherwise, it will be rendered as a route and override the parent route.
				superAdminVersionOverride: true,
				requiredVersion: requiredVersion('1.0.0')
			},
			{
				key: 'users',
				id: 'menu-management-user-list',
				keyparent: 'management',
				path: 'users',
				pathWithChild: '/*',
				label: '__lst.title%_user',
				component: UsersMain,
				loggedInActive: true,
				published: true,
				superAdminVersionOverride: true,
				requiredVersion: requiredVersion('1.2.0')
			},
			{
				key: 'budget',
				path: 'budget',
				id: 'menu-management-budget',
				pathWithChild: '/*',
				label: '_budget',
				component: BudgetMain,
				loggedInActive: true,
				checkPermission: true,
				published: true,
				table: 'budget',
				requiredVersion: requiredVersion('1.2.0')
			},
			{
				key: 'recruitments',
				path: 'recruitments',
				id: 'menu-management-recruitments',
				pathWithChild: '/*',
				label: '_recruitment.multiple',
				component: RecruitmentMain,
				loggedInActive: true,
				checkPermission: true,
				published: true,
				table: 'recruitments',
				requiredVersion: requiredVersion('1.2.0')
			},
			{
				key: 'meetings',
				path: 'meetings',
				id: 'menu-meetings',
				pathWithChild: '/*',
				label: '_meeting.multiple',
				component: MeetingsMain,
				published: true,
				table: 'meetings',
				requiredVersion: requiredVersion('1.2.0') // 1.2.0 or // 1.0.0
			}
		]
	},
	{
		key: 'billing',
		label: 'single.billing',
		id: 'menu-billing',
		loggedInActive: true,
		icon: CreditCardOutlined,
		appType: 'client',
		published: _routesSideIsPublished('billing'),
		collapsedTitle: true,
		requiredVersion: requiredVersion('1.0.0'),
		children: [
			{
				key: 'subscriptions',
				keyparent: 'billing',
				id: 'menu-billing-subscriptions',
				path: 'subscriptions',
				label: '_subscription',
				component: Subscriptions,
				loggedInActive: true,
				appType: 'client',
				published: true,
				requiredVersion: requiredVersion('1.0.0')
			}
		]
	},
	{
		key: 'features',
		label: '_feature.multiple',
		id: 'menu-features',
		type: 'group',
		requiredVersion: requiredVersion('1.0.0'),
		children: [
			{
				key: 'sprints',
				path: 'sprints',
				id: 'menu-features-sprints',
				pathWithChild: '/*',
				label: '_sprint.multiple',
				component: SprintsMain,
				loggedInActive: true,
				icon: FireOutlined,
				published: _routesSideIsPublished('sprints'),
				checkPermission: true,
				table: 'sprints',
				requiredVersion: requiredVersion('1.0.0')
			},
			{
				key: 'workflows',
				path: 'workflows',
				id: 'menu-features-workflows',
				pathWithChild: '/*',
				label: '_workflow.multiple',
				component: WorkflowsMain,
				loggedInActive: true,
				icon: ApartmentOutlined,
				published: _routesSideIsPublished('workflows'),
				checkPermission: true,
				table: 'workflows',
				requiredVersion: requiredVersion('1.3.0')
			},
			{
				key: 'monthly-reports',
				path: 'monthly-reports',
				id: 'menu-features-monthly-reports',
				pathWithChild: '/*',
				label: '_monthly-report.multiple',
				component: MonthlyReportsMain,
				loggedInActive: true,
				icon: BarChartOutlined,
				published: _routesSideIsPublished('monthly-reports'),
				checkPermission: true,
				table: 'monthly_reports',
				requiredVersion: requiredVersion('1.2.0')
			},
			{
				key: 'requests',
				path: 'requests',
				pathWithChild: '/*',
				id: 'menu-features-monthly-requests',
				label: '_request.multiple',
				component: RequestsMain,
				loggedInActive: true,
				icon: WechatOutlined,
				published: _routesSideIsPublished('requests'),
				checkPermission: true,
				table: 'requests',
				requiredVersion: requiredVersion('1.0.0')
			},
			{
				key: 'secured',
				path: 'secured',
				pathWithChild: '/*',
				id: 'menu-features-monthly-secured',
				label: 'single.secured.label',
				component: SecuredMain,
				loggedInActive: true,
				icon: LockOutlined,
				published: _routesSideIsPublished('secured'),
				table: 'secured',
				requiredVersion: requiredVersion('1.3.0')
			}
		]
	},
	{
		key: 'info',
		label: 'single.info',
		id: 'menu-info',
		type: 'group',
		loggedInActiveLabel: true,
		requiredVersion: requiredVersion('1.0.0'),
		children: [
			{
				key: 'products',
				label: '_product.multiple',
				id: 'menu-info-products',
				loggedInActive: false,
				icon: ThunderboltOutlined,
				published: true,
				appType: 'client',
				collapsedTitle: true,
				requiredVersion: requiredVersion('1.0.0'),
				children: [
					{
						key: '/products/ai-wp-public-chat',
						label: '_product.ai-wp-public-chat',
						id: 'menu-info-ai-wp-public-chat',
						path: 'products/ai-wp-public-chat',
						component: AiWpPublicChat,
						appType: 'client',
						published: _routesSideProductsIsPublished(
							'/products/ai-wp-public-chat'
						),
						requiredVersion: requiredVersion('1.0.0'),
						seo: {
							title: 'AI WP Public Chat :: On Subscription',
							meta: {
								description:
									'Discover AI WP Public Chat by On Subscription, an innovative AI-powered chat solution for WordPress websites. Enhance user engagement and support with cutting-edge technology.',
								'og:title':
									'AI WP Public Chat :: On Subscription',
								'og:description':
									'AI-powered chat solution for WordPress websites by On Subscription.',

								'twitter:title':
									'AI WP Public Chat :: On Subscription',
								'twitter:description':
									'Enhance your WordPress site with AI WP Public Chat from On Subscription.'
							}
						}
					}
				]
			},
			{
				key: 'services',
				label: 'single.services',
				id: 'menu-info-services',
				loggedInActive: false,
				icon: AppstoreOutlined,
				published: true,
				appType: 'client',
				collapsedTitle: true,
				requiredVersion: requiredVersion('1.0.0'),
				children: [
					{
						key: '/services/programming-tech/wordpress',
						path: 'services/programming-tech/wordpress',
						label: 'single.wordpress',
						id: 'menu-info-wordpress',
						component: Wordpress,
						loggedInActive: false,
						published: _routesSideServicesIsPublished(
							'/services/programming-tech/wordpress'
						),
						appType: 'client',
						requiredVersion: requiredVersion('1.0.0')
					},
					{
						key: '/services/programming-tech',
						path: 'services/programming-tech',
						label: 'single.programming-tech',
						id: 'menu-info-programming-tech',
						component: ProgrammingAndTech,
						loggedInActive: false,
						published: _routesSideServicesIsPublished(
							'/services/programming-tech'
						),
						appType: 'client',
						requiredVersion: requiredVersion('1.0.0')
					},
					{
						key: '/services/automations-and-ai',
						path: 'services/automations-and-ai',
						label: 'single.automations',
						id: 'menu-info-automations-and-ai',
						component: AutomationsAndAi,
						loggedInActive: false,
						published: _routesSideServicesIsPublished(
							'/services/automations-and-ai'
						),
						appType: 'client',
						requiredVersion: requiredVersion('1.0.0')
					},
					{
						key: '/services/digital-marketing',
						path: 'services/digital-marketing',
						label: 'single.digital-marketing',
						id: 'menu-info-digital-marketing',
						component: DigitalMarketing,
						loggedInActive: false,
						published: _routesSideServicesIsPublished(
							'/services/digital-marketing'
						),
						appType: 'client',
						requiredVersion: requiredVersion('1.0.0')
					},
					{
						key: '/services/business',
						path: 'services/business',
						label: 'single.business',
						id: 'menu-info-business',
						component: Business,
						loggedInActive: false,
						published:
							_routesSideServicesIsPublished(
								'/services/business'
							),
						appType: 'client',
						requiredVersion: requiredVersion('1.2.0')
					},
					{
						key: '/services/graphics-design',
						path: 'services/graphics-design',
						label: 'single.graphic-design',
						id: 'menu-info-graphics-design',
						component: GraphicsAndDesign,
						loggedInActive: false,
						published: _routesSideServicesIsPublished(
							'/services/graphics-design'
						),
						appType: 'client',
						requiredVersion: requiredVersion('1.2.0')
					},
					{
						key: '/services/writing-translation',
						path: 'services/writing-translation',
						label: 'single.writing-translation',
						id: 'menu-info-writing-translation',
						component: WritingAndTranslation,
						loggedInActive: false,
						published: _routesSideServicesIsPublished(
							'/services/writing-translation'
						),
						appType: 'client',
						requiredVersion: requiredVersion('1.2.0')
					}
				]
			},
			{
				key: 'documentation-main',
				label: '_documentation',
				id: 'menu-documentation',
				loggedInActive: true,
				icon: FileTextOutlined,
				published: true,
				collapsedTitle: true,
				requiredVersion: requiredVersion('1.3.0'),
				children: [
					{
						key: 'documentation',
						path: 'documentation',
						id: 'menu-documentation-main',
						pathWithChild: '/*',
						label: '_documentation.other',
						component: DocumentationMain,
						loggedInActive: true,
						published: _routesSideIsPublished('documentation'),
						checkPermission: true,
						requiredVersion: requiredVersion('1.3.0')
					}
				]
			}
		]
	}
]

const routesPages = [
	{
		key: 'home',
		path: '/',
		label: 'single.home',
		component: HomePage,
		loggedInActive: false,
		published: _routesSidePagesIsPublished('home'),
		appType: 'client',
		requiredVersion: requiredVersion('1.0.0'),
		seo: {
			title: 'On Subscription :: Automations and AI for digital business',
			meta: {
				description:
					'On Subscription provides cutting-edge automations and AI solutions to streamline your digital business operations. Explore our services and boost your productivity today!',
				'og:title':
					'On Subscription :: Automations and AI for digital business',
				'og:description':
					'AI-powered automation and digital business tools by On Subscription.',
				'twitter:title':
					'On Subscription :: Automations and AI for digital business',
				'twitter:description':
					'AI automations and digital business tools for teams.'
			}
		}
	},
	{
		key: 'home-team',
		path: '/',
		label: 'single.home-team',
		component: HomePageTeam,
		loggedInActive: false,
		published: _routesSidePagesIsPublished('home-team'),
		appType: 'team',
		requiredVersion: requiredVersion('1.0.0')
	},
	{
		key: 'blog',
		path: 'blog',
		pathWithChild: '/*',
		label: 'single.blog',
		component: BlogMain,
		loggedInActive: false,
		published: _routesSidePagesIsPublished('blog'),
		appType: 'client',
		requiredVersion: requiredVersion('1.1.0')
	},
	{
		key: 'about-us',
		path: 'about-us',
		label: 'single.about-us',
		component: AboutUs,
		loggedInActive: false,
		published: _routesSidePagesIsPublished('about-us'),
		appType: 'client',
		requiredVersion: requiredVersion('1.1.0')
	},
	{
		key: 'contact-us',
		path: 'contact-us',
		label: 'single.contact-us',
		component: ContactUs,
		loggedInActive: false,
		published: _routesSidePagesIsPublished('contact-us'),
		requiredVersion: requiredVersion('1.0.0')
	},
	{
		key: 'recruitment-apply',
		path: 'recruitment/apply',
		label: 'single.apply-for-job',
		component: RecruitmentApply,
		loggedInActive: false,
		published: _routesSidePagesIsPublished('recruitment-apply'),
		requiredVersion: requiredVersion('1.2.0')
	},
	{
		key: 'meeting-setter',
		path: 'meeting/setter',
		label: '_meeting.setter',
		component: MeetingsSetter,
		loggedInActive: false,
		published: _routesSidePagesIsPublished('meeting-setter'),
		requiredVersion: requiredVersion('1.2.0')
	},
	{
		key: 'terms-and-conditions',
		path: 'terms-and-conditions',
		label: 'single.terms-and-conditions',
		component: TermsAndConditions,
		loggedInActive: false,
		published: _routesSidePagesIsPublished('terms-and-conditions'),
		appType: 'client',
		requiredVersion: requiredVersion('1.0.0')
	},
	{
		key: 'privacy-policy',
		path: 'privacy-policy',
		label: 'single.privacy-policy',
		component: PrivacyPolicy,
		loggedInActive: false,
		published: _routesSidePagesIsPublished('privacy-policy'),
		appType: 'client',
		requiredVersion: requiredVersion('1.0.0')
	}
]

const cvPages = [
	{
		key: 'cv-wordpress',
		path: 'cv/en/wordpress',
		label: 'single.blog',
		component: CvEnWordpress,
		loggedInActive: false,
		published: true,
		appType: 'client'
	},
	{
		key: 'cv-main',
		path: 'cv/en/main',
		label: 'single.blog',
		component: CvEnMain,
		loggedInActive: false,
		published: true,
		appType: 'client'
	},
	{
		key: 'cv-poster',
		path: 'cv/poster',
		label: 'single.poster',
		component: Poster,
		loggedInActive: false,
		published: true,
		appType: 'client'
	}
]
const routeLanguage = [
	{
		key: 'languages',
		icon: GlobalOutlined,
		label: 'single.language.settings',
		id: 'menu-languages',
		loggedInDisable: true,
		children: [
			{
				key: 'language',
				label: <LanguageSelector label="" type="list" />
			}
		]
	}
]
/**
 * Array containing all routes from the menu and sidebar including children flatten that have a path (not a group).
 */
const flattenRoutesList = []
function flattenRoutes(routes) {
	routes.forEach((route) => {
		if (route.path) flattenRoutesList.push(route)
		if (route.children) flattenRoutes(route.children)
	})
}
flattenRoutes(routesAccount)
flattenRoutes(routesSide)
flattenRoutes(routesPages)
flattenRoutes(cvPages)

export {
	routeLanguage,
	routesAccount,
	routesSide,
	routesPages,
	flattenRoutesList
}
